import { format } from 'owa-localize';
import { makeGetRequest } from 'owa-ows-gateway';

import { TODO_API_GET_TASK_FORMAT } from '../utils/constants';
import getTodoRequestHeaders from '../utils/getTodoRequestHeaders';

/**
 * Makes the Get task call to the server to get a single task item & returns the full response
 * @param {string} taskId the id of the task to retreive
 * @returns promise of Todo
 */
export default async function getTaskService(taskId: string): Promise<Response> {
    return makeGetRequest(
        format(TODO_API_GET_TASK_FORMAT, taskId),
        undefined /* correlationId */,
        true /* returnFullResponse */,
        getTodoRequestHeaders /* customHeaders */
    )
        .then(response => {
            return response;
        })
        .catch(er => {
            return er;
        });
}
